// extracted by mini-css-extract-plugin
export var danger = "_1b-6";
export var lightPink = "_1b-a";
export var medium = "_1b-j";
export var nearSquare = "_1b-m";
export var neutralBlue = "_1b-8";
export var neutralYellow = "_1b-7";
export var noCapitalize = "_1b-1";
export var normal = "_1b-2";
export var pill = "_1b-0";
export var primary = "_1b-3";
export var primaryLight = "_1b-4";
export var shadow = "_1b-n";
export var small = "_1b-k";
export var solidBlack = "_1b-i";
export var solidGreen = "_1b-d";
export var solidLightBlue = "_1b-f";
export var solidNavy = "_1b-e";
export var solidOrange = "_1b-h";
export var solidPink = "_1b-g";
export var solidRed = "_1b-b";
export var solidWhite = "_1b-9";
export var solidYellow = "_1b-c";
export var success = "_1b-5";
export var xsmall = "_1b-l";